var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-menu'),_vm._v(" "),_c('main-header'),_vm._v(" "),_c('about'),_vm._v(" "),_c('services'),_vm._v(" "),_c('coverage'),_vm._v(" "),_c('clients'),_vm._v(" "),_c('work'),_vm._v(" "),_c('contact')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f518760","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/vue/apps/App/App.vue
// module id = AxY9
// module chunks = 0